export const CONST = {
  BACKEND_URL: 'https://apixcvbr.blockwave.co.uk',
 }
